import type { ReactElement } from 'react';
import { Label, RadioButton, RadioField, RadioGroup } from 'react-aria-components';
import { Icon } from '../ui';
import s from './ActingFor.module.css';

export type ForWhomValue = 'me' | 'someone';

/**
 * "Who is this change for? Just me / For an Executive" (APP-148 D20, Budget board), and "Who is
 * this for? Just me / For a Sector Lead (Graham Whitlock)" on a withdraw: whether the action is
 * the Stock Admin's own or done for someone, chosen before the step's fields appear. The chosen
 * option is filled and ticked, so it never reads by colour alone.
 */
export function ForWhom({
  label,
  someone,
  value,
  onChange,
  isDisabled = false,
}: {
  label: string;
  /** "For an Executive", "For a Sector Lead (Graham Whitlock)". */
  someone: string;
  value: ForWhomValue;
  onChange: (value: ForWhomValue) => void;
  isDisabled?: boolean;
}): ReactElement {
  return (
    <RadioGroup
      className={s.choice}
      value={value}
      onChange={(next) => {
        onChange(next === 'someone' ? 'someone' : 'me');
      }}
      orientation="horizontal"
      isDisabled={isDisabled}
    >
      <Label className={s.fieldLabel}>{label}</Label>
      <div className={s.choiceOptions}>
        {(['me', 'someone'] as const).map((option) => (
          <RadioField key={option} value={option}>
            <RadioButton className={s.choiceOption}>
              {({ isSelected }) => (
                <>
                  {isSelected && <Icon name="check" size={16} />}
                  {option === 'me' ? 'Just me' : someone}
                </>
              )}
            </RadioButton>
          </RadioField>
        ))}
      </div>
    </RadioGroup>
  );
}
